import {
  TKIconDashboard,
  TKIconProjects,
  TKIconCardPOS,
  TKIconConvertCard,
  TKIconSettings,
} from "assets/images/svgs";

export const SidebarContent = [
  {
    route: "/ngo/dashboard",
    icon: <TKIconDashboard />,
    text: "Dashboard",
  },
  {
    route: "/ngo/projects",
    icon: <TKIconProjects />,
    text: "Projects",
  },
  {
    route: "/ngo/donations",
    icon: <TKIconCardPOS />,
    text: "Donations",
  },
  {
    route: "/ngo/transactions",
    icon: <TKIconConvertCard />,
    text: "Transactions",
  },
  {
    route: "/ngo/settings",
    icon: <TKIconSettings />,
    text: "Settings",
  },
];
